import { MenuTemplateEnum } from '../../__generated__/graphql'

export const hasDarkTemplates = (template: MenuTemplateEnum) => {
  if (!template) {
    return null
  }
  return [MenuTemplateEnum.Black, MenuTemplateEnum.Black2].includes(template)
}
